export const bookingsHc = {
  firstCheckinSend: {
    badge: "Automatyzacja",
    title: "Kiedy wysyłane są informacje o przyjeździe?",
    desc: "Włącz każde zdarzenie i zdecyduj, <strong>kiedy</strong> ma zostać wysłane: gdy <strong>jeden gość</strong> ukończy swoją rejestrację, czy dopiero wtedy, gdy <strong>wszyscy</strong> goście z rezerwacji ukończą rejestrację.",
    loading: "Wczytywanie ustawień…",
    welcomeName: "Wiadomość powitalna",
    welcomeSub: "Wiadomość powitalna, którą gość otrzymuje zaraz po ukończeniu rejestracji.",
    documentName: "Dokument z podpisanym regulaminem",
    documentSub: "To dokument, który gość podpisuje podczas rejestracji. Wysyłamy go jako PDF, aby miał go na WhatsApp lub w poczcie e-mail.",
    timingIndividual: "Gdy gość ukończy swoją rejestrację",
    timingAll: "Gdy wszyscy goście z rezerwacji ukończą rejestrację",
    timingQuestion: "Kiedy jest wysyłane?",
    eventOffNote: "To zdarzenie nie będzie wysyłane automatycznie.",
    infoBox: "Zmiany zapisują się automatycznie. Klucz dostępu, gdy obiekt ma inteligentny zamek, ma własną konfigurację.",
    loadError: "Nie udało się wczytać ustawień.",
    saveError: "Nie udało się zapisać ustawień. Spróbuj ponownie.",
  },
  checkinProcess: {
    colEmail: "E-mail",
    colSendDate: "Data wysyłki",
    colStatus: "Status",
    unspecified: "Nie podano",
    complete: "Ukończony",
    pending: "Oczekuje",
  },
  listBookings: {
    title: "Lista check-in",
    subtitle: `Rejestr check-in Twoich gości`,
    accommodation: "Obiekt",
    all: "Wszystkie",
    from: "Od",
    to: "Do",
    search: "Szukaj",
    today: "Dziś",
    noDate: "Brak daty",
    clear: "Wyczyść",
    exporting: "Eksportowanie...",
    exportCheckins: "Eksportuj",
    ricevutaBtn: "Potwierdzenie policji",
    ricevutaTitle: "Potwierdzenie włoskiej policji",
    ricevutaHint: "Oficjalne potwierdzenie Alloggiati Web ze wszystkimi zameldowaniami wysłanymi każdego dnia. Jeden dzień pobiera PDF; kilka – ZIP z jednym PDF na dzień (maks. 31).",
    ricevutaFrom: "Od",
    ricevutaTo: "Do",
    ricevutaAccount: "Konto policji",
    ricevutaDownload: "Pobierz PDF",
    ricevutaDownloading: "Pobieranie…",
    ricevutaCancel: "Anuluj",
    ricevutaError: "Nie udało się pobrać potwierdzenia.",
    noAccommodation: "Brak obiektu",
    noReservation: "Brak rezerwacji",
    travelerReport: "Raport o podróżnych (Mossos)",
    noRecords: "Brak wpisów",
    noRecordsFiltered: "Nie znaleziono wpisów dla zastosowanych filtrów.",
    noCheckinsTitle: "Nie ma jeszcze zarejestrowanych check-in",
    noCheckinsSub: `Gdy goście ukończą swój check-in, zobaczysz ich tutaj wraz ze wszystkimi danymi.`,
    excelSuccess: "Check-in pobrane do pliku Excel",
    excelSuccessTitle: "Eksport zakończony",
    excelError: `Nie udało się wyeksportować check-in`,
    errorTitle: "Błąd",
    listingNotIdentified: "Nie udało się zidentyfikować oferty dla tego check-in",
    comprobanteNotAvailable: "Potwierdzenie nie jest jeszcze dostępne dla tego check-in",
    comprobanteDownloadError: "Nie udało się pobrać potwierdzenia",
  },
  modalFirstCheckin: {
    loading: "Wczytywanie...",
    sendingLinkWait: "Wysyłanie linku do check-in, proszę czekać...",
    phoneRequired: "Aby kontynuować, należy podać numer WhatsApp",
    sendingLink: "Wysyłanie linku ...",
    almostThere: "Już prawie gotowe, proszę czekać...",
    sentSuccess: "Wysłano pomyślnie",
    sendError: "Błąd wysyłania check-in",
    title: "Wypróbuj teraz proces check-in na własnym telefonie",
    enterWhatsapp: "Podaj swój numer WhatsApp",
    invalidNumber: `Nieprawidłowy numer. Pamiętaj o prefiksie "+".`,
    skip: "Pomiń",
    sendFirstCheckin: "Wyślij swój pierwszy check-in",
    sendCheckin: "Wyślij check-in",
  },
  tableRetriveCheckinPending: {
    colEmail: "E-mail",
    colSendDate: "Data wysyłki",
    colStatus: "Status",
    unspecified: "Nie podano",
    complete: "Ukończony",
    pending: "Oczekuje",
    emptyMessage: `Nie masz jeszcze żadnego check-in w toku`,
  },
  rerservationModal: {
    night: "noc",
    nights: "nocy",
    minStayBanner: "Wybrany zakres ma ograniczenie minimalnego pobytu wynoszące {count} {nights} (zasada OTA). Wybrane noce: {selected}.",
    freeUnits: "Wolne jednostki: {count}",
    noAvailabilityDetailed: "Brak dostępności w tych terminach. {details}",
    noAvailability: "Brak dostępności w tych terminach.",
    hotelAvailabilityError: "Nie udało się zweryfikować dostępności (hotel).",
    minStayWarning: "Dla dnia przyjazdu wymagane jest minimum {count} nocy. Wybrano {selected}.",
    notEnoughAvailability: "Dostępność jest niewystarczająca. Wolne jednostki: {count}.",
    noAvailabilityDates: "Brak dostępności w wybranych terminach.",
    departureAfterArrival: "Wyjazd musi być późniejszy niż przyjazd.",
    close: "Zamknij",
    noMatches: "Brak wyników",
    noAccommodations: "Nie ma żadnych obiektów",
    searchingGuests: "Wyszukiwanie gości...",
    noName: "Brak nazwiska",
    priceLocked: "Ceny rezerwacji nie można zmienić.",
    otaMoveHint: "Możesz przenieść ją do innego obiektu w tej samej ofercie; kanał zostanie o tym powiadomiony.",
    otaMoveHintCuenta: "Możesz przenieść ją do dowolnego ze swoich obiektów. Jeśli to ta sama oferta, kanał zostanie powiadomiony.",
    otaRelocateNote: "To inna oferta: rezerwacja zostanie przeniesiona w WACheckin, ale kanał zachowa ją w obiekcie, w którym została sprzedana. Jej zmiany i anulowanie nadal będą do Ciebie docierać.",
    extrasTitle: "Inne opcje",
    extrasSub: "Zaznacz, co pobierasz i jaką zniżkę stosujesz",
    quoteTitle: "Co nalicza Twoja rezerwacja bezpośrednia",
    quoteHint: "Zaznacz, co chcesz naliczyć w tej rezerwacji. Noclegi są zawsze wliczone.",
    quoteOptions: "1 do zaznaczenia | {count} do zaznaczenia | {count} do zaznaczenia",
    quoteNoExtras: "Ten obiekt nie ma ustawionej opłaty za sprzątanie ani innych opłat w rezerwacji bezpośredniej.",
    quoteStay: "Pobyt · {count} noc | Pobyt · {count} noce | Pobyt · {count} nocy",
    quoteExtraGuest: "Dodatkowy gość | {count} dodatkowi goście | {count} dodatkowych gości",
    quoteDiscount: "Zniżki i promocje",
    quoteOccupancyDiscount: "Zniżka za obłożenie",
    quoteCleaning: "Opłata za sprzątanie",
    quoteTotal: "Razem",
    quoteUse: "Użyj tej ceny",
    quoteNoRate: "Brak taryfy na te terminy: wpisz cenę samodzielnie.",
    quoteLinePrice: "Cena za ten obiekt",
    unitsAdd: "Dodaj kolejny obiekt z oferty…",
    unitsGuests: "Goście w tym obiekcie",
    unitsRemove: "Usuń z rezerwacji",
    unitsGroupError: "Nie udało się utworzyć rezerwacji na kilka obiektów.",
    resendTitle: "Wyślij ponownie wiadomość z potwierdzeniem",
    resendSub: "Ponownie wysyła gościowi szablon potwierdzenia.",
    resendNote: "Po zmodyfikowaniu rezerwacji <strong>szablon potwierdzenia zostanie wysłany ponownie</strong> dla tej rezerwacji.",
    saving: "Zapisywanie...",
  },
};
